import { Stage } from 'application/stage'
import { createStore, restore, sample } from 'effector'
import { useStore } from 'effector-react'
import { CarsWidgetList } from 'features/cars-widget/components/cars-widget-list'
import { CarsWidgetSlider } from 'features/cars-widget/components/cars-widget-slider'
import { CarsWidgetProps } from 'features/cars-widget/types'
import { useEffect, useState } from 'react'

import { fetchCitiesFx, fetchWidgetCarsFx } from '../../features/cars-widget/model'
import { Container } from '../../ui/grid'
import { StageError } from '../../ui/stage-error'

const $failed = sample({
  clock: [fetchCitiesFx?.fail, fetchWidgetCarsFx?.fail],
  fn: () => true,
  target: createStore(false)
})

const $hasNoCars = restore(
  fetchWidgetCarsFx?.doneData?.map((response) => response?.cars?.length < 1),
  false
)

export const CarsWidget: Stage<CarsWidgetProps> = (props) => {
  const [showWidget, setShowWidget] = useState(false)
  const failed = useStore($failed)
  const hasNoCars = useStore($hasNoCars)

  useEffect(() => {
    if (!hasNoCars) {
      setShowWidget(true)
    }
  }, [hasNoCars])

  if (failed) {
    return (
      <Container>
        <StageError>{props?.errorText}</StageError>
      </Container>
    )
  }

  return (
    <>
      {showWidget ? (
        <Container>{props?.showAsSlider ? <CarsWidgetSlider {...props} /> : <CarsWidgetList {...props} />}</Container>
      ) : null}
    </>
  )
}

export default CarsWidget
